import React from 'react';

import { Box, LinearProgress } from '@mui/material';
import PropTypes from 'prop-types';

import useStyles from './setupProgressbarStyles';

const SetupProgressbar = ({ completedSteps, totalSteps }) => {
    const classes = useStyles();

    // Hide progress bar if no steps are completed
    if (completedSteps === 0) {
        return null;
    }

    const progress = totalSteps > 0 ? (completedSteps / totalSteps) * 100 : 0;

    return (
        <Box className={classes.progressBarContainer}>
            <LinearProgress
                variant="determinate"
                value={progress}
                className={classes.progressBar}
            />
        </Box>
    );
};

SetupProgressbar.propTypes = {
    completedSteps: PropTypes.number,
    totalSteps: PropTypes.number,
};

export default SetupProgressbar;
